export const REGIONEAEREOPARTENZA = 'REGIONEAEREOPARTENZA'